const tabsInit = () => {
    $(".cf-btn-tab a.fl-button").attr('href', 'javascript:void(0)');

    $(".cf-btn-tab a.fl-button").on('click', (event) => {
      event.preventDefault();
      $(".cf-btn-tab a.fl-button").removeClass('active');
      $("[class*='cf-content-tab']").hide();

      $btn = $(event.currentTarget).closest("[class*='cf-btn-tab']");
      $(event.currentTarget).addClass('active');

      const id = $btn.attr('id').split('-');
      const index = id.slice(-1);
      $(`.cf-content-tab-${index}`).show();
    });

    // If Beaver Builder edit mode is not active, then click the first tab.
    if (!$('html').hasClass('fl-builder-edit')) {
      $("#cf-tab-1 a.fl-button").click();
    }
};

(($) => {
  $(document).ready(() => {
    tabsInit();
  });
})(jQuery);
